module.exports = __webpack_public_path__ + "static/AK-6b4b6a3207460f2615cbe088d50f70b1.svg";